import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/fonts/open-sans.css";
import "./global.css"; //global styles imported before all, component styles strictly after all.
import { App } from "./app";

const root = ReactDOM.createRoot(document.querySelector('.root'));
root.render(React.createElement(App, {}));